export default function(scheduler){

let temp_section;
let before;

scheduler.config.collision_limit = 1;

function _setTempSection(event_id) { // for custom views (matrix, timeline, units)
	const checked_mode = scheduler._get_section_view();
	if(checked_mode && event_id){
		temp_section = scheduler.getEvent(event_id)[scheduler._get_section_property()];
	}
}

scheduler.attachEvent("onBeforeDrag",function(id){
	_setTempSection(id);
	return true;
});
scheduler.attachEvent("onBeforeLightbox",function(id){
	const ev = scheduler.getEvent(id);
	before = [ev.start_date, ev.end_date];
	_setTempSection(id);
	return true;
});
scheduler.attachEvent("onEventChanged",function(id){
	if (!id || !scheduler.getEvent(id)) return true;
	const ev = scheduler.getEvent(id);
	if (!scheduler.checkCollision(ev)){
		if (!before) return false;
		ev.start_date = before[0];
		ev.end_date = before[1];
		ev._timed=this.isOneDayEvent(ev);
	}
	return true;
});
scheduler.attachEvent("onBeforeEventChanged",function(ev,e,is_new){
	return scheduler.checkCollision(ev);
});
scheduler.attachEvent("onEventAdded",function(id,ev) {
	const result = scheduler.checkCollision(ev);
	if (!result)
		scheduler.deleteEvent(id);
});
scheduler.attachEvent("onEventSave",function(id, edited_ev, is_new){
	edited_ev = scheduler._lame_clone(edited_ev);
	edited_ev.id = id;

	//lightbox may not have 'time' section
	if(!(edited_ev.start_date && edited_ev.end_date)){
		const ev = scheduler.getEvent(id);
		edited_ev.start_date = new Date(ev.start_date);
		edited_ev.end_date = new Date(ev.end_date);
	}

	if((edited_ev.rrule && !edited_ev.recurring_event_id) || edited_ev.rec_type){
		scheduler._roll_back_dates(edited_ev);
	}
	return scheduler.checkCollision(edited_ev); // in case user creates event on one date but then edited it another
});

scheduler._check_sections_collision = function(first, second){
	const map_to = scheduler._get_section_property();
	if (first[map_to] == second[map_to] && first.id != second.id)
		return true;
	return false;
};

scheduler.checkCollision = function(ev) {
	let evs = [];
	const collision_limit = scheduler.config.collision_limit;

	if (ev.rec_type) {
		let evs_dates = scheduler.getRecDates(ev);
		for (let k = 0; k < evs_dates.length; k++) {
			let tevs = scheduler.getEvents(evs_dates[k].start_date,evs_dates[k].end_date);
			for (let j = 0; j < tevs.length; j++) {
				if ((tevs[j].event_pid || tevs[j].id) != ev.id)
					evs.push(tevs[j]);
			}
		}
	} else if (ev.rrule) {
		let evs_dates = scheduler.getRecDates(ev);
		for (let k = 0; k < evs_dates.length; k++) {
			let tevs = scheduler.getEvents(evs_dates[k].start_date,evs_dates[k].end_date);
			for (let j = 0; j < tevs.length; j++) {
				if ((String(tevs[j].id).split("#")[0] || tevs[j].id) != ev.id)
					evs.push(tevs[j]);
			}
		}
	} else {
		evs = scheduler.getEvents(ev.start_date, ev.end_date);
		for (let i = 0; i < evs.length; i++) {
			let concurrent = evs[i];
			// for recurring legacy
			if (concurrent.id == ev.id || (concurrent.event_length && [concurrent.event_pid, concurrent.event_length].join("#") == ev.id)) {
				evs.splice(i,1);
				break;
			}
			//for recurring rrule
			if (concurrent.recurring_event_id && [concurrent.recurring_event_id, concurrent._pid_time].join("#") == ev.id) {
				evs.splice(i,1);
				break;
			}
		}
	}

	const checked_mode = scheduler._get_section_view();
	const map_to = scheduler._get_section_property();

	let single = true;
	if (checked_mode) { // custom view
		let count = 0;

		for (let i = 0; i < evs.length; i++){
			if (evs[i].id != ev.id && this._check_sections_collision(evs[i], ev))
				count++;
		}

		if (count >= collision_limit) {

			single = false;
		}
	}
	else {
		if ( evs.length >= collision_limit )
			single = false;
	}
	if (!single) {
		let res = !scheduler.callEvent("onEventCollision",[ev,evs]);
		if (!res) {
			ev[map_to] = temp_section||ev[map_to]; // from _setTempSection for custom views
		}
		return res;
	}
	return single;

};

}